import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import * as flowConfig from "flows/market-mix-modelling/config";
import { projectIsMarketMixModelling } from "flows/market-mix-modelling/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsMarketMixModelling(project)) {
    return null;
  }

  const wsId = project.workspaces[0]?.workspace;

  return (
    <div className="m-1">
      <p>
        Sales Column:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.TARGET_VAR_KEY]}
        </span>
      </p>
      <p>
        Time Column:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.TIMESTAMP_VAR_KEY]}
        </span>
      </p>
      <p>
        Grouping Columns:{" "}
        <span className="underline">
          {(project.meta_data[flowConfig.GROUPING_VARS_KEY] || []).length >= 1
            ? project.meta_data[flowConfig.GROUPING_VARS_KEY].join(", ")
            : "None"}
        </span>
      </p>
      {wsId && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
